<template>
    <div id="blogPageControls">

        <div class="control">
            <span v-if="this.lastBlog">
                <nuxt-link :to="'/blog/' + this.blog.data[this.lastBlogId].slug" class="control-btn">
                    <img src="/img/sb-amenities/prev-arrow.png" alt="Prev" class="w-100">
                </nuxt-link>
            </span>

        </div>

        <div class="control">
            <span v-if="this.nextBlog">
                <nuxt-link :to="'/blog/' + this.blog.data[this.nextBlogId].slug" class="control-btn">
                    <img src="/img/sb-amenities/next-arrow.png" alt="Next" class="w-100">
                </nuxt-link>
            </span>
        </div>
    </div>
</template>

<script>
import blogJson from '@/json/blog.json'

export default {
    props: [
        'blogId'
    ],
    data() {
        return {
            currentBlogPost: this.$route,
            blog: blogJson,
            blogLength: blogJson.data.length,
            blogLength1: blogJson.data.length-1
        }
    },
    computed: {
        lastBlog: {
            get() {
                if (this.blogId > 0) {
                // this.lastBlog = true;
                return true;
                } else {
                // this.lastBlog = false;
                return false;
                }
            },
            set() {

            }
        },
        lastBlogId() {
            if (this.blogId > 0) {
                this.lastBlog = true;
                return this.blogId - 1;
            } else {
                this.lastBlog = false;
                return;
            }
        },
        nextBlog() {
            if (this.blogId == this.blogLength1) {
                // this.lastBlog = true;
                return false;
            } else {
                // this.lastBlog = false;
                return true;
            }
        },
        nextBlogId() {
            if (this.blogId < this.blogLength1) {
                // this.nextBlog = true;
                return this.blogId + 1;
            } else {
                // this.nextBlog = false;
                return;
            }
        }
    },
    // mounted() {
    //     // this.blogPosts = blogPostsData
    //     // console.log(this.blogPosts)
    //     this.blogLength = this.blog.length
    //     this.blogLength1 = this.blog.length-1;
    //     console.log(this.blog[0].pageLink)

    // },
    methods: {
        checkRoute() {
            console.log(this.$route.name)
        }
    }
}
</script>

<style lang="scss">
#blogPageControls {
    width: 100%;
    padding-top: 60px;
    text-align: right;

    .control {
        display: inline-block;

        .control-btn {
            border: 1px solid #0b2340;
            display: block;
            padding: 10px;
        }

        a {
            color: #000;
            margin: 0 5px;
            text-decoration: none;
            transition: 0.25s ease-in-out;

            &:hover {
                color: #d8262e;
            }

            img {
                max-width: 120px;
            }

        span {
                font-family: 'Gotham-Light';
                font-size: 0.85rem;
                margin: 0 10px;
            }
        }
    }   

    .controlBorder {
        text-align: center;
        width: 1px;
        height: 25px;
        background-color: #000;
        display: inline-block;
        vertical-align: bottom;
    }
}
</style>